var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbusinessVerifyUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1A73E8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("rect", {
    x: 275.335,
    y: -756.31,
    width: 442.371,
    height: 427.687,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 449.013 -382.052 L 675.013 -608.052 L 618.013 -665.052 L 449.013 -496.052 L 365.013 -580.052 L 308.013 -523.052 L 449.013 -382.052 Z M 491.013 -124.052 C 398.346 -147.385 321.846 -200.552 261.513 -283.552 C 201.18 -366.552 171.013 -458.719 171.013 -560.052 L 171.013 -804.052 L 491.013 -924.052 L 811.013 -804.052 L 811.013 -560.052 C 811.013 -458.719 780.846 -366.552 720.513 -283.552 C 660.18 -200.552 583.68 -147.385 491.013 -124.052 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbusinessVerifyUser);
export default __webpack_public_path__ + "static/media/gbusiness-verify-user.99a620b5961e079d7ca9be25c6590650.svg";
export { ForwardRef as ReactComponent };